import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import {PlottingDetails} from '../../../../models/plotting-map-details'
import { loadModules } from 'esri-loader';
import { setDefaultOptions } from 'esri-loader';
import { AppConfigService } from '../../../../core/config/app-config.service';
import esri = __esri;

@Component({
  selector: 'app-esri-map',
  templateUrl: './esri-map.component.html',
  styleUrls: ['./esri-map.component.css']
})
export class EsriMapComponent implements OnInit {

  @Output() mapLoaded = new EventEmitter<boolean>();
  @ViewChild('mapViewNode', { static: true }) private mapViewEl: ElementRef;

  private afterviewinitexecuted = false;

  /**
   * @private _zoom sets map zoom
   * @private _center sets map center
   * @private _basemap sets type of map
   */
  private _zoom: number = 10;
  private _center: Array<number> = [-122.4194, 37.7749];
  private _basemap: string = 'streets';
  private _plotingData:any;
  private _plotingOpenData:PlottingDetails[]=[];
  private _plotingClosedData:PlottingDetails[]=[];
  private _plotingLimitationData:PlottingDetails[]=[];

  @Input()
  set zoom(zoom: number) {
    this._zoom = zoom;
  }

  get zoom(): number {
    return this._zoom;
  }

  @Input()
  set center(center: Array<number>) {
    this._center = center;
  }

  get center(): Array<number> {
    return this._center;
  }

  @Input()
  set basemap(basemap: string) {
    this._basemap = basemap;
  }

  get basemap(): string {
    return this._basemap;
  }

  @Input()
  set plotingData(plotingData: any) {
    this._plotingData = plotingData;
  }

  get plotingData(): any {
    return this._plotingData;
  }

  

  constructor() { }

  ngafterviewinit() {
    this.afterviewinitexecuted = true; 
}

  async initializeMap() {
    try {
      
      // setDefaultOptions({ version: '4.13' });
      const [EsriMap, EsriMapView,EsriFeatureLayer, EsriBasemapToggle] = await loadModules([
        'esri/Map',
        'esri/views/MapView',
        "esri/layers/FeatureLayer",
        "esri/widgets/BasemapToggle"
      ]);
             
      const gisMassInfoURL = AppConfigService.settings.AppConfig.GISMASSINFOURL;

        // let basemap = "topo-vector";
        // let nextBasemap = "hybrid";

        this._plotingData.forEach(item => {
          if(item.siteStatus=="OPEN")
          {
            this._plotingOpenData.push(item)
          }
          else if(item.siteStatus=="CLOSED")
          {
            this._plotingClosedData.push(item)
          }
          else if(item.siteStatus=="CLOSED WITH USE LIMITATION"){
            this._plotingLimitationData.push(item)
          }
        });
        const openData = this._plotingOpenData;
        const closedData = this._plotingClosedData;
        const limitationData = this._plotingLimitationData;
        

      
      // Set type of map
      const mapProperties: esri.MapProperties = {
        basemap: "topo-vector"
      };
      

      const map: esri.Map = new EsriMap(mapProperties);

      // Set type of map view
      const mapViewProperties: esri.MapViewProperties = {
        container: this.mapViewEl.nativeElement,
        center: this._center,
        zoom: this._zoom,
        map: map
      };

  

      
      const closedLayer = new EsriFeatureLayer({
        source: closedData.map((d, i) => (
            {
                geometry: {
                    type: "point",
                    longitude: d.lon,
                    latitude: d.lat
                },
                attributes: {
                    ObjectID: i,
                    siteName:d.siteName,
                  rtn:d.rtn,
                  address:d.address,
                  town:d.town,
                  status:d.status,
                    ...d
                }
            }
        )),
        fields: [
            {
                name: "ObjectID",
                alias: "ObjectID",
                type: "oid"
            },
            {
                name: "siteName",
                alias: "Site Name",
                type: "string"
            },
            {
                name: "rtn",
                alias: "RTN",
                type: "string"
            },
            {
                name: "address",
                alias: "Address",
                type: "string"
            },
            {
              name: "town",
              alias: "Town",
              type: "string"
          },
          {
            name: "status",
            alias: "Status",
            type: "string"
        },
            {
                name: "notes",
                alias: "Notes",
                type: "string"
            },
            {
                name: "lat",
                alias: "Latitude",
                type: "double"
            },
            {
                name: "lon",
                alias: "Longitude",
                type: "double"
            },
        ],
        objectIDField: ["ObjectID"],
        geometryType: "point",
        renderer: {
            type: "simple",
            symbol: {
                type: "text",
                color: "blue",
                text: "\ue613",
                font: {
                    size: 15,
                    family: "CalciteWebCoreIcons"
                }
            }
        },
        popupTemplate: {
            title: "{name}",
            content: function (feature) {
                const ObjectID = feature.graphic.attributes;
                const div = document.createElement("div");
                div.innerHTML = 
                  `<b>Site Name:</b>` + feature.graphic.attributes.siteName +
                  `<br><b>RTN:</b>` + feature.graphic.attributes.rtn +
                  `<br><b>Address:</b>` + feature.graphic.attributes.address + 
                  `<br>    <b>Town:</b>` + feature.graphic.attributes.town +
                  `<br>  <b>Status:</b> ` + feature.graphic.attributes.status +
                  `<br>   <b>Notes:</b> Map location approximated by Address Match <br><br>
                   Click <a href="detailviewer/` + feature.graphic.attributes.rtn +`">here</a> for more information on this site.<br>
                   Click <a href="` + gisMassInfoURL +`">here</a> for location questions.`
                
                return div;
              },
            outFields: ["*"]
        }
    });

    map.add(closedLayer);

    const openLayer = new EsriFeatureLayer({
      source: openData.map((d, i) => (
          {
              geometry: {
                  type: "point",
                  longitude: d.lon,
                  latitude: d.lat
              },
              attributes: {
                  ObjectID: i,
                  siteName:d.siteName,
                  rtn:d.rtn,
                  address:d.address,
                  town:d.town,
                  status:d.status,
                  ...d
              }
          }
      )),
      fields: [
          {
              name: "ObjectID",
              alias: "ObjectID",
              type: "oid"
          },
          {
              name: "siteName",
              alias: "Site Name",
              type: "string"
          },
          {
              name: "rtn",
              alias: "RTN",
              type: "string"
          },
          {
              name: "address",
              alias: "Address",
              type: "string"
          },
          {
            name: "town",
            alias: "Town",
            type: "string"
        },
        {
          name: "status",
          alias: "Status",
          type: "string"
      },
          {
              name: "notes",
              alias: "Notes",
              type: "string"
          },
          {
              name: "lat",
              alias: "Latitude",
              type: "double"
          },
          {
              name: "lon",
              alias: "Longitude",
              type: "double"
          },
      ],
      objectIDField: ["ObjectID"],
      geometryType: "point",
      renderer: {
          type: "simple",
          symbol: {
              type: "text",
              color: "red",
              text: "\ue613",
              font: {
                  size: 15,
                  family: "CalciteWebCoreIcons"
              }
          }
      },
      popupTemplate: {
          title: "{name}",
          content: function (feature) {
            const ObjectID = feature.graphic.attributes;
            const div = document.createElement("div");
            div.innerHTML = 
              `<b>Site Name:</b>` + feature.graphic.attributes.siteName +
              `<br><b>RTN:</b>` + feature.graphic.attributes.rtn +
              `<br><b>Address:</b>` + feature.graphic.attributes.address + 
              `<br>    <b>Town:</b>` + feature.graphic.attributes.town +
              `<br>  <b>Status:</b> ` + feature.graphic.attributes.status +
              `<br>   <b>Notes:</b> Map location approximated by Address Match <br><br>
               Click <a href="detailviewer/` + feature.graphic.attributes.rtn +`">here</a> for more information on this site.<br>
               Click <a href="` + gisMassInfoURL +`">here</a> for location questions.`
            
            return div;
          },
          outFields: ["*"]
      }
  });

  map.add(openLayer);

  const limitationlayer = new EsriFeatureLayer({
    source: limitationData.map((d, i) => (
        {
            geometry: {
                type: "point",
                longitude: d.lon,
                latitude: d.lat
            },
            attributes: {
                ObjectID: i,
                siteName:d.siteName,
                  rtn:d.rtn,
                  address:d.address,
                  town:d.town,
                  status:d.status,
                ...d
            }
        }
    )),
    fields: [
        {
            name: "ObjectID",
            alias: "ObjectID",
            type: "oid"
        },
        {
            name: "siteName",
            alias: "Site Name",
            type: "string"
        },
        {
            name: "rtn",
            alias: "RTN",
            type: "string"
        },
        {
            name: "address",
            alias: "Address",
            type: "string"
        },
        {
          name: "town",
          alias: "Town",
          type: "string"
      },
      {
        name: "status",
        alias: "Status",
        type: "string"
    },
        {
            name: "notes",
            alias: "Notes",
            type: "string"
        },
        {
            name: "lat",
            alias: "Latitude",
            type: "double"
        },
        {
            name: "lon",
            alias: "Longitude",
            type: "double"
        },
    ],
    objectIDField: ["ObjectID"],
    geometryType: "point",
    renderer: {
        type: "simple",
        symbol: {
            type: "text",
            color: "green",
            text: "\ue613",
            font: {
                size: 15,
                family: "CalciteWebCoreIcons"
            }
        }
    },
    popupTemplate: {
        title: "{name}",
        content: function (feature) {
            const ObjectID = feature.graphic.attributes;
            const div = document.createElement("div");
            div.innerHTML = 
              `<b>Site Name:</b>` + feature.graphic.attributes.siteName +
              `<br><b>RTN:</b>` + feature.graphic.attributes.rtn +
              `<br><b>Address:</b>` + feature.graphic.attributes.address + 
              `<br>    <b>Town:</b>` + feature.graphic.attributes.town +
              `<br>  <b>Status:</b> ` + feature.graphic.attributes.status +
              `<br>   <b>Notes:</b> Map location approximated by Address Match <br><br>
               Click <a href="detailviewer/` + feature.graphic.attributes.rtn +`">here</a> for more information on this site.<br>
               Click <a href="` + gisMassInfoURL +`">here</a> for location questions.`
            
            return div;
          },
        outFields: ["*"]
    }
});

map.add(limitationlayer);

      const mapView: esri.MapView = new EsriMapView(mapViewProperties);
      
      const toggle = new EsriBasemapToggle({
        view: mapView, 
        nextBasemap: "hybrid"
      });    
 

      toggle.watch('activeBasemap', function (basemap) {
        console.log("current basemap title: ", basemap.title);
    });

    mapView.on("click", function(event){
      // event is the event handle returned after the event fires.
      console.log(event.mapPoint);
    });
      //mapView.add(toggle, "top-right");
      mapView.ui.add(toggle, "top-left");
     // mapView.ui.add(toggle, "top-right");
      // All resources in the MapView and the map have loaded.
      // Now execute additional processes
      mapView.when(() => {
        
        this.mapLoaded.emit(true);
      });
    } catch (error) {
            alert("Internal Server Error - Something went Wrong");
    }

  }

 
  

  ngOnInit() {
    this.initializeMap();
  }

}
